// Module
var code = "<header> <div class=\"heading\"> <h3>Alerts</h3> </div> <div class=\"controls\"> <button class=\"btn icon cancel\"> <i class=\"material-icons\">close</i> </button> </div> </header> <div class=\"modal-body application-progress-container alert-modal\"> <div class=\"alerts-list\"></div> </div> ";
// Exports
export default code;